export default __webpack_public_path__ + "static/media/01-main.70cbf4ea.jpeg";